<template>
  <div>
    <div class="contact-container" :style="{ backgroundImage: `url(${url}/home/contact_bg.png)` }" @click="handleClick">
      <img :src="`${url}/home/contact_icon.png`" alt="" class="contact-icon" />
      <div class="contact-title">联系我们</div>
    </div>

    <el-dialog v-model="dialogVisible" class="contact-dialog" :show-close="true" :lock-scroll="false" align-center width="1040px">
      <div class="contact-content">
        <div class="contact-dialog-title">
          <img :src="`${url}/home/title_left_icon.png`" alt="" />
          <div class="contact-dialog-title-text">联系我们</div>
          <img :src="`${url}/home/title_left_icon.png`" alt="" />
        </div>

        <div class="contact-form-panel">
          <div class="contact-form-row">
            <div class="contact-form-item">
              <span class="field-label field-label--right">姓名：</span>
              <el-input v-model="form.name" placeholder="请输入您的姓名" />
            </div>
            <div class="contact-form-item">
              <span class="field-label field-label--right">联系方式：</span>
              <el-input v-model="form.tel" placeholder="请输入您的手机号" />
            </div>
          </div>

          <div class="contact-form-row">
            <div class="contact-form-item">
              <span class="field-label field-label--right">咨询类型：</span>
              <el-select v-model="form.typeremark" placeholder="请选择咨询类型">
                <el-option label="业务类" value="业务类" />
                <el-option label="技术类" value="技术类" />
              </el-select>
            </div>
            <div class="contact-form-item">
              <span class="field-label field-label--right">邮箱地址：</span>
              <el-input v-model="form.email" placeholder="请输入您的邮箱地址" />
            </div>
          </div>

          <div class="contact-form-row contact-form-row-full">
            <div class="contact-form-item contact-form-item-full">
              <span class="field-label field-label--right">需求问题：</span>
              <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请详细描述您的需求或问题" />
            </div>
          </div>
        </div>

        <div class="contact-company-panel">
          <div class="company-title">小鹿柯基网络科技有限公司联系信息</div>
          <div class="contact-form-row">
            <div class="contact-form-item">
              <span class="field-label field-label--right">联系电话：</span>
              <el-input v-model="company.tel" readonly />
            </div>
            <div class="contact-form-item">
              <span class="field-label field-label--right">电子邮箱：</span>
              <el-input v-model="company.email" readonly />
            </div>
          </div>
          <div class="contact-form-row contact-form-row-full">
            <div class="contact-form-item">
              <span class="field-label field-label--right">工作时间：</span>
              <el-input v-model="company.time" readonly />
            </div>
            <div class="contact-form-item contact-form-item--spacer" aria-hidden="true"></div>
          </div>
        </div>

        <div class="contact-footer">
          <el-button class="btn-cancel" @click="dialogVisible = false">关闭窗口</el-button>
          <el-button type="primary" class="btn-submit" @click="submitForm" :loading="loading">提交咨询</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { url } from '@/api'
import { ref, reactive } from 'vue'
// import app from '@/utils/app'
import axios from 'axios'

const dialogVisible = ref(false)
const loading = ref(false)

const form = reactive({
  name: '',
  tel: '',
  typeremark: '',
  email: '',
  content: ''
})

const company = reactive({
  tel: '0571-8888-8888',
  email: 'contact@drky.com',
  time: '周一至周五 9:00-18:00'
})

const handleClick = () => {
  dialogVisible.value = true
}

// 手机号校验函数
const validatePhone = (phone) => {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}

// 提交表单
const submitForm = async () => {
  if (!form.name) return ElMessage.warning('请输入姓名')
  
  // 手机号校验（新增）
  if (!form.tel) return ElMessage.warning('请输入手机号')
  if (!validatePhone(form.tel)) return ElMessage.warning('请输入正确的手机号格式')

  if (!form.typeremark) return ElMessage.warning('请选择咨询类型')
  if (!form.email) return ElMessage.warning('请输入邮箱')
  if (!form.content) return ElMessage.warning('请输入需求问题')

  loading.value = true

  try {
    const res = await axios.post('https://xlpmdl.ichangban.com/webTest/pmProjectTask/addXSJob', {
      ...form
    })

    ElMessage.success('提交成功！')
    dialogVisible.value = false

    Object.assign(form, {
      name: '',
      tel: '',
      typeremark: '',
      email: '',
      content: ''
    })

  } catch (err) {
    console.error('提交失败', err)
    ElMessage.error('提交失败，请稍后重试')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.contact-container {
  cursor: pointer;
  position: fixed;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  width: 84px;
  height: 157px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .contact-icon {
    width: 28px;
    height: 28px;
    margin-top: 55px;
  }

  .contact-title {
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 5px;
  }
}

:deep(.el-dialog.contact-dialog) {
  padding: 0 !important;
  background-image: url('https://xiaolu-pm.oss-cn-hangzhou.aliyuncs.com/xiaolu-website/home/contact_dialog_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  width: 1040px;
  height: 795px;
  background-color: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  position: absolute;
  top: 14px;
  right: 18px;
  padding: 0;
  margin: 0;
  width: 40px;
  height: 40px;
  background: transparent;
}

:deep(.el-dialog__title) {
  display: none;
}

:deep(.el-dialog__close) {
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #606266;
}

:deep(.el-dialog__body) {
  padding: 0 !important;
  height: 795px;
  box-sizing: border-box;
}

.contact-content {
  width: 100%;
  height: 100%;
  padding: 56px 42px 38px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.contact-dialog-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;

  img {
    width: 50px;
    height: 30px;
  }

  .contact-dialog-title-text {
    font-size: 32px;
    color: #333333;
    margin: 0 20px;
  }
}

.contact-form-panel,
.contact-company-panel {
  margin-top: 26px;
  padding: 26px 28px 18px;
  border-radius: 6px;
  border: 1px solid rgba(255, 220, 180, 0.75);
}

.contact-form-row {
  display: flex;
  margin-bottom: 16px;
}

.contact-form-row-full {
  margin-bottom: 0;
}

.contact-form-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.contact-form-item--spacer {
  pointer-events: none;
}

.contact-form-item-full {
  flex: 1;
  width: 100%;
}

.field-label {
  font-size: 16px;
  color: #909399;
  flex-shrink: 0;
}

.field-label--right {
  width: 100px;
  text-align: right;
  padding-right: 10px;
}

.contact-form-item :deep(.el-input),
.contact-form-item :deep(.el-select),
.contact-form-item :deep(.el-textarea) {
  width: 100%;
  flex: 1;
}

.contact-form-item :deep(.el-input__wrapper),
.contact-form-item :deep(.el-select__wrapper) {
  background: #ffffff;
  border-radius: 2px;
  border: none !important;
  box-shadow: none !important;
  width: 100%;
  height: 58px;
  padding: 0 14px;
  box-sizing: border-box;
}

.contact-form-item :deep(.el-input.is-focus .el-input__wrapper),
.contact-form-item :deep(.el-select.is-focused .el-select__wrapper),
.contact-form-item :deep(.el-textarea.is-focus .el-textarea__wrapper),
.contact-form-item :deep(.el-textarea__wrapper.is-focus) {
  border: none !important;
  box-shadow: none !important;
}

.contact-form-item :deep(.el-textarea__wrapper) {
  background: #ffffff;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.contact-form-item :deep(.el-textarea__inner) {
  resize: none;
  min-height: 78px;
  background: #ffffff;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  padding: 12px 14px !important;
}

.contact-form-item :deep(.el-textarea__inner:focus) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.company-title {
  text-align: center;
  font-size: 24px;
  color: #4D0000;
  margin-bottom: 20px;
  font-weight: 600;
}

.contact-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 70px;
  padding-top: 0;
}

.btn-cancel,
.btn-submit {
  width: 450px;
  height: 58px;
  font-size: 20px;
  border-radius: 2px;
}

.btn-cancel {
  margin-right: 0;
}

:deep(.btn-cancel.el-button) {
  background: #ffffff;
  border: 1px solid #ff9900 !important;
  color: #ff9900 !important;
}

:deep(.btn-submit.el-button--primary) {
  background: linear-gradient(140deg, #FA932A 0%, #FA5F31 100%);
  border: none;
  color: #ffffff;
}
</style>